
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/au",
      function () {
        return require("private-next-pages/au/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/au"])
      });
    }
  